import { Create } from "@/components/admin/create";
import { Edit } from "@/components/admin/edit";
import { List } from "@/components/admin/list";
import { DataTable } from "@/components/admin/data-table";
import { FormToolbar, SimpleForm } from "@/components/admin/simple-form";
import { OwnerToolbar } from "./OwnerLock";
import { FreightTabs } from "./FreightTabs";
import { TextInput } from "@/components/admin/text-input";
import { NumberInput } from "@/components/admin/number-input";
import { NumberField } from "@/components/admin/number-field";
import { DateInput } from "@/components/admin/date-input";
import { DateField } from "@/components/admin/date-field";
import { SelectInput } from "@/components/admin/select-input";
import { SelectField } from "@/components/admin/select-field";
import {
  CompanyField,
  CompanyInput,
  LaneField,
  LaneInput,
  ListActions,
  OwnerField,
  OwnerInput,
  money,
} from "./common";

export const quoteStatuses = ["draft", "sent", "won", "lost"].map((s) => ({
  id: s,
  name: s[0].toUpperCase() + s.slice(1),
}));
const filters = [
  <SelectInput
    key="s"
    source="status"
    choices={quoteStatuses}
    label="Status"
    alwaysOn
  />,
];

const QuoteForm = () => (
  <SimpleForm
    defaultValues={{ status: "draft" }}
    toolbar={
      <OwnerToolbar>
        <FormToolbar />
      </OwnerToolbar>
    }
  >
    <div className="grid grid-cols-2 gap-4 w-full">
      <CompanyInput />
      <LaneInput />
      <NumberInput source="rate" label="Rate ($)" />
      <SelectInput source="status" choices={quoteStatuses} label="Status" />
      <DateInput source="valid_until" label="Valid until" />
    </div>
    <OwnerInput />
    <TextInput source="notes" label="Notes" multiline />
  </SimpleForm>
);

// generated columns; never send back
const transform = ({ fts: _f, ...d }: any) => d;

export const QuoteList = () => (
  <List
    actions={<ListActions />}
    filters={filters}
    sort={{ field: "created_at", order: "DESC" }}
    title="Quotes"
  >
    <FreightTabs />
    <DataTable rowClick="edit">
      <DataTable.Col label="Customer">
        <CompanyField />
      </DataTable.Col>
      <DataTable.Col label="Lane">
        <LaneField />
      </DataTable.Col>
      <DataTable.Col label="Rate">
        <NumberField source="rate" options={money} />
      </DataTable.Col>
      <DataTable.Col label="Status">
        <SelectField source="status" choices={quoteStatuses} />
      </DataTable.Col>
      <DataTable.Col label="Valid until">
        <DateField source="valid_until" />
      </DataTable.Col>
      <DataTable.Col label="Agent">
        <OwnerField />
      </DataTable.Col>
    </DataTable>
  </List>
);
export const QuoteCreate = () => (
  <Create transform={transform} redirect="list" title="New quote">
    <QuoteForm />
  </Create>
);
export const QuoteEdit = () => (
  <Edit transform={transform} redirect="list" title="Edit quote">
    <QuoteForm />
  </Edit>
);
export default { list: QuoteList, create: QuoteCreate, edit: QuoteEdit };
